import { getIsPageBrokerVisible } from './getIsPageBrokerVisible';
import { getIsSnippetBrokerVisible } from './getIsSnippetBrokerButtonVisible';
import { IAppState } from '../../common/state';

export const getIsBrokerBannerVisible = (state: IAppState) => {
  const isPageBrokerVisible = getIsPageBrokerVisible(state);
  const isSnippetBrokerVisible = getIsSnippetBrokerVisible(state);

  return isPageBrokerVisible && !isSnippetBrokerVisible;
};
